<template>
  <div class="my-container">
    <el-form
      ref="lxpsForm"
      :rules="rules"
      label-width="120px"
      :hide-required-asterisk="false"
    >
      <!-- 阶段课题统计 -->
      <el-row>
        <el-col :span="24" class="label"> 阶段课题统计 </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="课题所属年份" prop="sfjx">
            <el-date-picker
              v-model="listQuery.startTime"
              type="year"
              :picker-options="startPickerOptions"
              format="yyyy"
              value-format="yyyy"
              @change="handleChange"
              :default-value="defaultValue"
              style="width: 100px"
              size="mini"
              :clearable="false"
            >
            </el-date-picker>
            ～
            <el-date-picker
              v-model="listQuery.endTime"
              type="year"
              :picker-options="endPickerOptions"
              format="yyyy"
              :clearable="false"
              value-format="yyyy"
              @change="handleChange"
              :default-value="defaultValue"
              style="width: 100px"
              size="mini"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="课题所属部门" prop="sfjx">
            <el-select
              ref="gsbm"
              v-model="listQuery.gsbm"
              placeholder="请选择课题所属部门"
              clearable
              filterable
              size="small"
              style="width: 200px"
              @change="handleChange"
              class="filter-item"
            >
              <el-option
                v-for="item in bmOptions"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="课题属性" prop="sfjx">
            <el-select
              ref="ktsx"
              v-model="listQuery.ktsx"
              placeholder="请选择课题属性"
              clearable
              filterable
              @change="handleChange"
              size="small"
              style="width: 200px"
              class="filter-item"
            >
              <el-option
                v-for="item in ktsxOptions"
                :key="item.dictValue"
                :label="item.dictLabel"
                :value="item.dictValue"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <div v-show="hasData">
          <el-col :span="12">
            <div class="list">
              <span v-for="(item, index) in data" :key="index">
                <div class="item">
                  <span>{{ item.year }}参加立项数：</span>
                  <span>{{ item.lxcount }}</span>
                </div>
                <div class="item">
                  <span>{{ item.year }}参加结项数：</span>
                  <span>{{ item.jxcount }}</span>
                </div>
              </span>
            </div>
          </el-col>
          <el-col :span="12" style="height: 100%; position: relative">
            <div style="overflow-x: auto">
              <div class="charts_wrap_type_1" style="display: flex">
                <span v-for="(item, index) in data" :key="index">
                  <div
                    :id="`chart_type_1_${index}`"
                    class="chart_bar"
                    style="wdith: 300px"
                  ></div>
                  <div
                    style="
                      text-align: center;
                      bottom: 15px;
                      font-size: 16px;
                      width: 100%;
                      line-height: 44px;
                    "
                  >
                    {{ item.year }}
                  </div>
                </span>
              </div>
            </div>
            <div class="legend">
              <div v-for="(item, index) in listQuery.xdata" :key="index">
                <span></span><span>{{ item }}</span>
              </div>
            </div>
          </el-col>
        </div>
        <div v-show="!hasData" class="nodata">
          <div>
            <img src="@/img/nodata.png" alt="" />
          </div>
          <div>暂无数据</div>
        </div>
      </el-row>
      <!-- 年度课题统计 /* -->
      <el-row>
        <el-col :span="24" class="label"> 年度课题统计 </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="课题所属年份" prop="sfjx">
            <el-date-picker
              v-model="listQuery2.startTime"
              type="year"
              :picker-options="startPickerOptions2"
              format="yyyy"
              value-format="yyyy"
              @change="handleChange2"
              :default-value="defaultValue"
              style="width: 100px"
              size="mini"
              :clearable="false"
            >
            </el-date-picker>
            ～
            <el-date-picker
              v-model="listQuery2.endTime"
              type="year"
              :picker-options="endPickerOptions2"
              format="yyyy"
              :clearable="false"
              value-format="yyyy"
              @change="handleChange2"
              :default-value="defaultValue"
              style="width: 100px"
              size="mini"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="课题所属部门" prop="sfjx">
            <el-select
              ref="gsbm"
              v-model="listQuery2.gsbm"
              placeholder="请选择课题所属部门"
              clearable
              filterable
              size="small"
              style="width: 200px"
              @change="handleChange2"
              class="filter-item"
            >
              <el-option
                v-for="item in bmOptions"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="课题属性" prop="sfjx">
            <el-select
              ref="ktsx"
              v-model="listQuery2.ktsx"
              placeholder="请选择课题属性"
              clearable
              filterable
              @change="handleChange2"
              size="small"
              style="width: 200px"
              class="filter-item"
            >
              <el-option
                v-for="item in ktsxOptions"
                :key="item.dictValue"
                :label="item.dictLabel"
                :value="item.dictValue"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <div v-show="hasData2">
          <el-col :span="12">
            <div class="list">
              <span v-for="(item, index) in data2" :key="index">
                <div class="item">
                  <span>{{ item.year }}年结项率：</span>
                  <span>{{ item.jxl }}</span>
                </div>
              </span>
            </div>
          </el-col>
          <el-col :span="12" style="height: 100%; position: relative">
            <div style="overflow-x: auto; min-height: 300px">
              <div class="charts_wrap_type_2" style="display: flex">
                <span v-for="(item, index) in data" :key="index">
                  <div
                    :id="`chart_type_2_${index}`"
                    class="chart_bar"
                    style="wdith: 300px"
                  ></div>
                  <div
                    style="
                      text-align: center;
                      bottom: 15px;
                      font-size: 16px;
                      width: 100%;
                      line-height: 44px;
                    "
                  >
                    {{ item.year }}
                  </div>
                </span>
              </div>
            </div>
            <div class="legend">
              <div v-for="(item, index) in listQuery2.xdata" :key="index">
                <span></span><span>{{ item }}</span>
              </div>
            </div>
          </el-col>
        </div>
        <div v-show="!hasData2" class="nodata">
          <div>
            <img src="@/img/nodata.png" alt="" width="240" />
          </div>
          <div>暂无数据</div>
        </div>
      </el-row>

      <!-- 部门课题统计 /* -->
      <el-row>
        <el-col :span="24" class="label"> 部门课题统计 </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="课题所属年份" prop="sfjx">
            <el-date-picker
              v-model="listQuery3.startTime"
              type="year"
              :picker-options="startPickerOptions3"
              format="yyyy"
              value-format="yyyy"
              @change="handleChange3"
              :default-value="defaultValue"
              style="width: 100px"
              size="mini"
              :clearable="false"
            >
            </el-date-picker>
            ～
            <el-date-picker
              v-model="listQuery3.endTime"
              type="year"
              :picker-options="endPickerOptions3"
              format="yyyy"
              :clearable="false"
              value-format="yyyy"
              @change="handleChange3"
              :default-value="defaultValue"
              style="width: 100px"
              size="mini"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="课题所属部门" prop="sfjx">
            <el-select
              ref="gsbm"
              v-model="listQuery3.gsbm"
              placeholder="请选择课题所属部门"
              clearable
              filterable
              size="small"
              style="width: 200px"
              @change="handleChange3"
              class="filter-item"
            >
              <el-option
                v-for="item in bmOptions"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="课题属性" prop="sfjx">
            <el-select
              ref="ktsx"
              v-model="listQuery3.ktsx"
              placeholder="请选择课题属性"
              clearable
              filterable
              @change="handleChange3"
              size="small"
              style="width: 200px"
              class="filter-item"
            >
              <el-option
                v-for="item in ktsxOptions"
                :key="item.dictValue"
                :label="item.dictLabel"
                :value="item.dictValue"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24" style="height: 100%; position: relative">
          <div style="overflow-x: auto" v-show="hasData3">
            <div class="charts_wrap_type_3" style="display: flex">
              <div
                :id="`chart_type_3`"
                style="height: 350px; width: 100%"
              ></div>
            </div>
          </div>
          <div v-show="!hasData3" class="nodata">
            <div>
              <img src="@/img/nodata.png" alt="" width="240" />
            </div>
            <div>暂无数据</div>
          </div>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import moment from "moment";
import { mapGetters } from "vuex";
import { getDictData } from "@/api/task.js";
import { getCourseStatistics, getCourseQueryCondition } from "@/api/course.js";
import * as echarts from "echarts";

export default {
  computed: {
    ...mapGetters(["deptUser", "user"]),
  },
  data() {
    return {
      startPickerOptions: {
        disabledDate: (time) => {
          if (!this.listQuery.endTime) {
            return time.getTime() < new Date(1970 - 1 - 1).getTime(); //禁止选择1970年以前的日期
          } else {
            return time.getTime() > new Date(this.listQuery.endTime);
          }
        },
      },
      endPickerOptions: {
        disabledDate: (time) => {
          return (
            time.getTime() < new Date(this.listQuery.startTime) ||
            time.getTime() < new Date(1970 - 1 - 1).getTime() //禁止选择1970年以前的日期
          );
        },
      },
      startPickerOptions2: {
        disabledDate: (time) => {
          if (!this.listQuery.endTime) {
            return time.getTime() < new Date(1970 - 1 - 1).getTime(); //禁止选择1970年以前的日期
          } else {
            return time.getTime() > new Date(this.listQuery.endTime);
          }
        },
      },
      endPickerOptions2: {
        disabledDate: (time) => {
          return (
            time.getTime() < new Date(this.listQuery.startTime) ||
            time.getTime() < new Date(1970 - 1 - 1).getTime() //禁止选择1970年以前的日期
          );
        },
      },
      startPickerOptions3: {
        disabledDate: (time) => {
          if (!this.listQuery.endTime) {
            return time.getTime() < new Date(1970 - 1 - 1).getTime(); //禁止选择1970年以前的日期
          } else {
            return time.getTime() > new Date(this.listQuery.endTime);
          }
        },
      },
      endPickerOptions3: {
        disabledDate: (time) => {
          return (
            time.getTime() < new Date(this.listQuery.startTime) ||
            time.getTime() < new Date(1970 - 1 - 1).getTime() //禁止选择1970年以前的日期
          );
        },
      },
      defaultValue: null,
      bmList: [],
      listQuery: {
        gsbm: null,
        startTime: null,
        endTime: null,
        ktsx: null,
        xdata: [],
      },
      listQuery2: {
        gsbm: null,
        startTime: null,
        endTime: null,
        ktsx: null,
      },
      listQuery3: {
        gsbm: null,
        startTime: null,
        endTime: null,
        ktsx: null,
      },
      ktsxOptions: [],
      bmOptions: [],
      data: {},
      data2: {},
      data3: {},
      hasData: true,
      hasData2: true,
      hasData3: true,
    };
  },
  created() {
    this.listQuery.startTime = moment()
      .year(moment().year() - 2)
      .format("YYYY");
    this.listQuery.endTime = moment().format("YYYY");
    this.listQuery2.startTime = moment()
      .year(moment().year() - 2)
      .format("YYYY");
    this.listQuery2.endTime = moment().format("YYYY");
    this.listQuery3.startTime = moment()
      .year(moment().year() - 2)
      .format("YYYY");
    this.listQuery3.endTime = moment().format("YYYY");

    const params1 = {
      type: 1,
      nf: `${moment(this.listQuery.startTime).format("YYYY")}-${moment(
        this.listQuery.endTime
      ).format("YYYY")}`,
      gsbm: this.listQuery.gsbm,
      ktsx: this.listQuery.ktsx,
    };
    const params2 = {
      type: 2,
      nf: `${moment(this.listQuery2.startTime).format("YYYY")}-${moment(
        this.listQuery2.endTime
      ).format("YYYY")}`,
      gsbm: this.listQuery2.gsbm,
      ktsx: this.listQuery2.ktsx,
    };
    const params3 = {
      type: 3,
      nf: `${moment(this.listQuery3.startTime).format("YYYY")}-${moment(
        this.listQuery3.endTime
      ).format("YYYY")}`,
      gsbm: this.listQuery3.gsbm,
      ktsx: this.listQuery3.ktsx,
    };
    getDictData("pmp_course_group", 1).then((res) => {
      if (res.code === 0) {
        this.ktsxOptions = res.data;
      }
    });
    //归属部门
    getCourseQueryCondition({ type: 1 }).then((res) => {
      if (res.code === 0) {
        this.bmOptions = res.data;
      }
    });
    this.getData(params1);
    this.getData(params2);
    this.getData(params3);
  },
  mounted() {},
  methods: {
    getData(params) {
      getCourseStatistics(params).then((res) => {
        if (res.code == 0) {
          if (params.type == 1) {
            this.data = res.data;
            let id = null;
            document.querySelector(".charts_wrap_type_1").style.width =
              this.data.length * 300 + "px";
            if (res.data && res.data.length > 0) {
              this.hasData = true;
              this.listQuery.xdata = res.data[0].xdata;
              for (let i = 0; i < res.data.length; i++) {
                id = "chart_type_1_" + i;
                this.renderChart(id, res.data[i].xdata, res.data[i].ydata);
              }
            } else {
              this.hasData = false;
            }
          } else if (params.type == 2) {
            this.data2 = res.data;
            let id = null;
            document.querySelector(".charts_wrap_type_2").style.width =
              this.data.length * 300 + "px";
            if (res.data && res.data.length > 0) {
              this.hasData2 = true;
              this.listQuery2.xdata = res.data[0].xdata;
              for (let i = 0; i < res.data.length; i++) {
                id = "chart_type_2_" + i;
                this.renderChart(id, res.data[i].xdata, res.data[i].ydata);
              }
            } else {
              this.hasData2 = false;
            }
          } else if (params.type == 3) {
            this.data3 = res.data;
            let id = null;
            if (
              !this.data3["立项数"].xdata.length ||
              this.data3["立项数"].xdata.length == 0
            ) {
              this.hasData3 = false;
              return;
            }
            this.hasData3 = true;
            id = "chart_type_3";
            this.renderChart3(
              id,
              this.data3["立项数"].xdata,
              this.data3["立项数"].ydata,
              this.data3["结项数"].ydata
            );
          }
        }
      });
    },
    renderChart(id, x, y) {
      setTimeout(() => {
        var chartDom = document.getElementById(id);
        var myChart = echarts.init(chartDom);
        var option;
        option = {
          grid: {
            x: 30,
            y: 30,
            x2: 0,
            y2: 0,
          },
          xAxis: {
            type: "category",
            data: x,

            axisLabel: {
              show: false,
            },
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              show: false,
            },
          },
          yAxis: {
            type: "value",
            axisLabel: {
              show: false,
            },
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              show: false,
            },
          },
          series: [
            {
              data: y,
              type: "bar",
              barWidth: "40px",

              itemStyle: {
                normal: {
                  label: {
                    show: true,
                    position: "top",
                  },
                  barBorderRadius: [15, 15, 0, 0],
                  color: function (params) {
                    //注意，如果颜色太少的话，后面颜色不会自动循环，最好多定义几个颜色
                    var colorList = [
                      "#0000A1",
                      "#1F6ED4",
                      "#39BAE8",
                      "#B9EDF8",
                    ];
                    return colorList[params.dataIndex];
                  },
                },
              },
            },
          ],
        };

        option && myChart.setOption(option);
      }, 200);
    },

    renderChart3(id, x, y1, y2) {
      setTimeout(() => {
        var chartDom = document.getElementById(id);
        var myChart = echarts.init(chartDom);
        var option;
        option = {
          grid: {
            y2: 100,
          },
          legend: {
            bottom: "0%",
            center: "0%",
          },
          xAxis: {
            type: "category",
            data: x,
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              show: false,
            },
            axisLabel: {
              rotate: 45,
            },
          },
          yAxis: {
            type: "value",
            axisLabel: {
              show: false,
            },
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              show: false,
            },
          },
          series: [
            {
              data: y1,
              type: "bar",
              barWidth: "20px",
              name: "立项数",
              itemStyle: {
                normal: {
                  label: {
                    show: true,
                    position: "top",
                  },
                  barBorderRadius: [15, 15, 0, 0],
                  color: "#0000A1",
                },
                emphasis: {
                  borderColor: "#fff",
                  borderWidth: 1,
                },
              },
            },
            {
              data: y2,
              type: "bar",
              name: "结项数",
              barWidth: "20px",
              itemStyle: {
                normal: {
                  label: {
                    show: true,
                    position: "top",
                  },
                  barBorderRadius: [15, 15, 0, 0],
                  color: "#1F6ED4",
                },
              },
              barGap: "0",
            },
          ],
        };

        option && myChart.setOption(option);
      }, 200);
    },
    handleChange() {
      const params1 = {
        type: 1,
        nf: `${moment(this.listQuery.startTime).format("YYYY")}-${moment(
          this.listQuery.endTime
        ).format("YYYY")}`,
        gsbm: this.listQuery.gsbm,
        ktsx: this.listQuery.ktsx,
      };
      this.getData(params1);
    },
    handleChange2() {
      const params2 = {
        type: 2,
        nf: `${moment(this.listQuery2.startTime).format("YYYY")}-${moment(
          this.listQuery2.endTime
        ).format("YYYY")}`,
        gsbm: this.listQuery2.gsbm,
        ktsx: this.listQuery2.ktsx,
      };
      this.getData(params2);
    },
    handleChange3() {
      const params1 = {
        type: 3,
        nf: `${moment(this.listQuery3.startTime).format("YYYY")}-${moment(
          this.listQuery3.endTime
        ).format("YYYY")}`,
        gsbm: this.listQuery3.gsbm,
        ktsx: this.listQuery3.ktsx,
      };
      this.getData(params1);
    },
  },
};
</script>

<style lang="less" scoped>
.my-container {
  padding: 15px;
}
.label {
  font-size: 16px;
  font-weight: bold;
  height: 44px;
  line-height: 44px;
  padding-left: 15px;
}
.list {
  margin: 15px auto;
  width: 50%;
  font-size: 14px;
  line-height: 54px;
  color: #333;
  .item {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #036eb8;

    span:nth-of-type(2) {
      color: #036eb8;
      font-weight: 700;
    }
  }
}

.chart_bar {
  height: 350px;
  width: 300px;
  float: left;
}
.legend {
  display: flex;
  margin: 15px auto;
  justify-content: center;
  div {
    display: flex;
    margin-right: 10px;
    span:nth-of-type(1) {
      height: 14px;
      width: 26px;
      background: #0000a1;
      border-radius: 3px;
      margin-right: 10px;
    }
  }
  div:nth-of-type(2) {
    span:nth-of-type(1) {
      background: #1f6ed4;
    }
  }
  div:nth-of-type(3) {
    span:nth-of-type(1) {
      background: #39bae8;
    }
  }
  div:nth-of-type(4) {
    span:nth-of-type(1) {
      background: #b9edf8;
    }
  }
}
.nodata {
  text-align: center;
  color: #999;
  font-size: 16px;
  div {
    margin-bottom: 0;
  }
}
</style>